export const PermissionChannel = {
    PUT: "mgr-channel-**-PUT",
    POST: "mgr-channel-POST",
    DELETE: "mgr-channel-**-DELETE",
    GET: "mgr-channel-search-GET",
    GET_UUID: "mgr-channel-**-GET"
};